module.exports = __webpack_public_path__ + "static/media/tell-me-im-pretty.ca44b866.jpg";